import * as ApiWithToken from "../callApiWithToken";

const dataListService = {
  getCountryListBySubregion: async function () {
    return ApiWithToken.getApi(
      process.env.REACT_APP_GENERAL_API + `DataList/getCountriesList`
    );
  },
  getSubretailListByCountry: async function (countryId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_GENERAL_API +
        `DataList/getSubretailListByCountry?CountryID=${countryId}`
    );
  },
  getUsersByRoleAndCountry: async function (countryId: number, roleId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_GENERAL_API +
        `DataList/getUsersByRoleAndCountry?CountryID=${countryId}&RoleID=${roleId}`
    );
  },
  getCoordinatorBySubRegion: async function () {
    return ApiWithToken.getApi(
      process.env.REACT_APP_GENERAL_API + `DataList/getCoordinatorBySubRegion`
    );
  },
  getSupervisorByCoordinator: async function (coordinatorId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_GENERAL_API +
        `DataList/getSupervisorByCoordinator?coordinatorId=${coordinatorId}`
    );
  },
  getAdvisorCategories: async function (languageId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_GENERAL_API +
        `DataList/GetAdvisorCategories?languageId=${languageId}`
    );
  },
  getFundsHP: async function () {
    return ApiWithToken.getApi(
      process.env.REACT_APP_GENERAL_API +
        `DataList/GetFundsHP`
    );
  },
  getSupervisorBySubRegion: async function () {
    return ApiWithToken.getApi(
      process.env.REACT_APP_GENERAL_API + `DataList/getSupervisorList`
    );
  },
};

export default dataListService;
